import { Storage } from "@xt/xtbase";
import { getDynamicFiatMarketCodes, isFiatMarketCode } from "./fiatMarket";

/**
 * 【法币展示/决策 统一逻辑】推荐法币 → CFD 默认币对。
 * 仅命中既是法币又存在交易对的推荐法币；否则兜底 U 本位。
 */

// 默认法币本位交易对（BRL），供法币区域使用
export const DEFAULT_FIAT_SYMBOL = "btc_brl_cfd";
// 兜底为 U 本位（已去掉现货，跳转交易统一用 CFD）
export const DEFAULT_U_SYMBOL = "btc_usdt_cfd";

// 缓存 key
const CACHE_KEY = "cfd_default_symbol_by_ip";
const CACHE_EXPIRE_TIME = 24 * 60 * 60 * 1000; // 24小时

/**
 * 根据推荐列表获取默认的 CFD 交易对
 * 只信 recommendedCurrencyList 中第一个可交易法币；否则兜底 U 本位。
 * @returns {Promise<string>} 返回交易对符号，如 "btc_usdt_cfd" 或 "btc_aed_cfd"
 */
export async function getCfdSymbolByIP() {
  try {
    const recommendedPayload = Storage.get("recommendedCurrencyList") || {};
    const recommendedCurrencies = Array.isArray(recommendedPayload?.currencies) ? recommendedPayload.currencies : [];
    const dynamicFiatCodes = getDynamicFiatMarketCodes();
    const recommendedFiat = recommendedCurrencies.find((item) => {
      const code = String(item?.currency || item?.currencyCode || "").toUpperCase();
      return code && dynamicFiatCodes.includes(code);
    });
    const recommendedFiatCode = String(recommendedFiat?.currency || recommendedFiat?.currencyCode || "").toUpperCase();
    if (recommendedFiatCode && isFiatMarketCode(recommendedFiatCode)) {
      return "btc_" + recommendedFiatCode.toLowerCase() + "_cfd";
    }
    return DEFAULT_U_SYMBOL;
  } catch (error) {
    console.warn("Failed to get CFD symbol by IP:", error);
    return DEFAULT_U_SYMBOL;
  }
}

/**
 * 同步获取缓存的 CFD 交易对（如果缓存存在）
 * @returns {string|null} 返回缓存的交易对，如果没有缓存则返回 null
 */
export function getCachedCfdSymbol() {
  const cached = Storage.get(CACHE_KEY);
  if (cached && cached.symbol && cached.timestamp) {
    const now = Date.now();
    if (now - cached.timestamp < CACHE_EXPIRE_TIME) {
      return cached.symbol;
    }
  }
  return null;
}
